export enum DocumentIssueChoice{
	None = 'c224a757-4771-4214-a91f-085bf62a9029',
	UnsupportedFileType= '872f93c3-6cb0-45f9-ba22-c67e2d5d684b',
	FailedToConvertToPdf= '4550dfe3-85ec-485b-99fe-118a16374d43',
	FailedToUploadOriginal= 'aa0354f5-fa8a-4dbe-b4e6-ba5d174d9eeb',
	FailedToIndex= '36a81e1b-6ef4-4e53-82ee-1baacd50cf49',
	FailedToExtractContainerFile= '9533027d-af71-4fd4-b774-6d2c1e93dcb3',
	FailedToRedactPdf =  'fc42f752-f4d0-4347-ada2-061eaebc01e4',
	MissingNormalizedPdfFile = '2b1dee28-4814-462e-ad31-6b2e93962cdd',
	ExceedsPageCountThreshold = '986e5050-6e2a-4b2e-b1ae-40b09212db85'
}
	